// Grov enhetsetikett til aktivitetsloggen: plattform og nettleser, ingen versjoner eller fingeravtrykk.
export function deviceLabel(ua = typeof navigator !== 'undefined' ? navigator.userAgent : '') {
  if (!ua) return 'Ukjent enhet';
  const os = /iPhone|iPad/.test(ua) ? 'iPhone'
    : /Android/.test(ua) ? 'Android'
    : /Windows/.test(ua) ? 'Windows'
    : /Macintosh|Mac OS X/.test(ua) ? 'Mac'
    : /Linux/.test(ua) ? 'Linux' : null;
  const browser = /Edg\//.test(ua) ? 'Edge'
    : /SamsungBrowser/.test(ua) ? 'Samsung Internet'
    : /Firefox|FxiOS/.test(ua) ? 'Firefox'
    : /Chrome|CriOS/.test(ua) ? 'Chrome'
    : /Safari/.test(ua) ? 'Safari' : null;
  if (!os && !browser) return 'Ukjent enhet';
  return [os, browser].filter(Boolean).join(' · ');
}
